export { ConclusionController };
window.ConclusionController = ConclusionController;
function ConclusionController(fullScreenController, prepareEmbed) {
   var template = prepareEmbed(window.embedHbsTemplates('EMBED_V4_CONCLUSION_HBS'));
   var element;

   function getElement(guide) {
      if (element) {
         return element;
      }
      guide.pageTitle = _js('Conclusion');
      element = template(guide);
      if (!fullScreenController.supported()) {
         element.find('.js-fullscreen').hide();
      }
      return element;
   }

   return {
      getElement: getElement,
   };
}
